/**
 * Calculates the Root Mean Square (RMS) of an array of audio samples.
 * Represents the average power and perceived loudness of the signal.
 */
export const calculateRms = <TArray extends ArrayLike<number>>(
  samples: TArray
): number => {
  if (samples.length === 0) {
    return 0;
  }

  let sumOfSquares = 0;

  for (let i = 0; i < samples.length; i += 1) {
    sumOfSquares += samples[i] * samples[i];
  }

  return Math.sqrt(sumOfSquares / samples.length);
};
